import * as React from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./components/layout/Sidebar";
import PricelistContent from "./components/layout/PricelistContent";
import { setSelectedDivisionId } from "app/shared/division/selectedDivisionStorage";
import "./Page.css";

export const DraftPage: React.FC = () => {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(true);

  React.useEffect(() => {
    const state = location.state as { divisionId?: number; year?: number } | undefined;
    const divisionId = state?.divisionId;
    if (typeof divisionId === "number" && divisionId > 0) {
      setSelectedDivisionId(divisionId);
    }
  }, [location.state]);

  const toggleSidebar = React.useCallback(() => {
    setIsSidebarOpen((v) => !v);
  }, []);

  const closeSidebar = React.useCallback(() => {
    setIsSidebarOpen(false);
  }, []);

  return (
    <div
      id="pricelist-page"
      className={`page ${isSidebarOpen ? "reduced" : ""}`}
    >
      <Sidebar isOpen={isSidebarOpen} onToggle={toggleSidebar} />
      <PricelistContent
        isSidebarOpen={isSidebarOpen}
        onRequestCloseSidebar={closeSidebar}
        isDraftMode
      />
    </div>
  );
};